<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Код</label>
            <crm-input-text
              [(value)]="status.code"
              [isError]="$any(errors?.code)"></crm-input-text>
            <small
              *ngIf="errors?.code"
              class="p-error">
              {{ errors.code | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Описание</label>
            <crm-input-text
              [(value)]="status.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0">
            <p-checkbox
              [(ngModel)]="status.expired"
              [binary]="true"
              inputId="expired"></p-checkbox>
            <label [for]="'expired'">Устаревший статус</label>
          </div>

          <div
            *ngIf="status['deleted']"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        class="p-button-success"
        [label]="saveButtonLabel"
        (click)="saveStatus()"></button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <button
          *ngIf="!status['deleted']"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteStatus()"></button>

        <button
          *ngIf="status['deleted']"
          pButton
          label="Восстановить"
          class="p-button-text"
          (click)="restoreStatus()"></button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
